import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '@/components/layout';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { Construction, Home, ArrowLeft, Mail } from 'lucide-react';

const AccountPage = () => {
  return (
    <Layout>
      <section className="min-h-[70vh] flex items-center justify-center bg-gradient-to-b from-muted/50 to-background">
        <div className="container-portico">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-xl mx-auto"
          >
            {/* Icon */}
            <div className="mb-8">
              <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
                <Construction className="w-12 h-12 text-primary" />
              </div>
            </div>

            {/* Content */}
            <h1 className="font-heading text-4xl md:text-5xl font-bold mb-4" data-testid="coming-soon-title">
              Coming Soon
            </h1>
            <p className="text-lg text-muted-foreground mb-8">
              We're working on something great! Our account portal is currently under development 
              and will be available soon.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <Link to="/">
                <Button variant="default" className="gap-2" data-testid="go-home-btn">
                  <Home className="w-4 h-4" />
                  Go to Homepage
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline" className="gap-2" data-testid="contact-btn">
                  <Mail className="w-4 h-4" />
                  Contact Us
                </Button>
              </Link>
            </div>

            {/* Back Link */}
            <button 
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
              data-testid="go-back-btn"
            >
              <ArrowLeft className="w-4 h-4" />
              Go back to previous page
            </button>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
};

export default AccountPage;
